/* HyperRecovery: add to cart without leaving the page, then show a slide-out confirmation. */
(() => {
  const drawer = document.querySelector('[data-cd]');
  const overlay = document.querySelector('[data-cd-overlay]');
  if (!drawer || !window.fetch) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = sel => drawer.querySelector(sel);
  let lastFocus = null;

  const money = (cents, currency) => {
    const whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency || 'AUD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100) + ' ' + (currency || 'AUD');
    } catch (e) { return '$' + (cents / 100).toLocaleString('en-AU') + ' ' + (currency || 'AUD'); }
  };

  const open = () => {
    lastFocus = document.activeElement;
    overlay.hidden = false; drawer.hidden = false;
    requestAnimationFrame(() => { overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
    document.documentElement.classList.add('cd-lock');
    setTimeout(() => $('.cd__close').focus(), 60);
  };
  const close = () => {
    overlay.classList.remove('is-open'); drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cd-lock');
    setTimeout(() => { overlay.hidden = true; drawer.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  drawer.querySelectorAll('[data-cd-close]').forEach(b => b.addEventListener('click', close));
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', e => {
    if (drawer.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...drawer.querySelectorAll('a[href],button:not([disabled])')].filter(el => el.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  const updateCount = count => {
    document.querySelectorAll('a[href$="/cart"].header__icon, a.header__icon[href*="cart"]').forEach(link => {
      let badge = link.querySelector('.cart-count');
      if (count > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; link.appendChild(badge); }
        badge.textContent = count;
      } else if (badge) badge.remove();
      link.setAttribute('aria-label', 'Cart with ' + count + ' items');
    });
  };

  const fill = (item, cart) => {
    $('[data-cd-error]').hidden = true;
    $('[data-cd-item]').hidden = false;
    $('[data-cd-heading]').textContent = 'Added to your cart';
    $('[data-cd-name]').textContent = item.product_title;
    const variant = $('[data-cd-variant]');
    variant.hidden = !item.variant_title || item.product_has_only_default_variant;
    variant.textContent = item.variant_title || '';
    $('[data-cd-price]').textContent = money(item.final_line_price != null ? item.final_line_price : item.price * item.quantity, cart.currency);
    const img = $('[data-cd-img]');
    img.innerHTML = '';
    if (item.image) {
      const el = new Image();
      el.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=240';
      el.alt = item.product_title; el.width = 120; el.height = 120;
      img.appendChild(el);
    }
    const hard = /hard-shell/i.test(item.product_type || '');
    const lead = hard ? drawer.dataset.leadHard + ' (may be longer while on back order)' : drawer.dataset.leadStd;
    $('[data-cd-lead]').textContent = 'Tested before dispatch, delivered in ' + lead;
    $('[data-cd-count]').textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    $('[data-cd-subtotal]').textContent = money(cart.total_price, cart.currency);
    updateCount(cart.item_count);
  };

  const showError = message => {
    $('[data-cd-heading]').textContent = 'Could not add to cart';
    $('[data-cd-item]').hidden = true;
    const err = $('[data-cd-error]');
    err.textContent = message || 'Something went wrong. Please try again or call us.';
    err.hidden = false;
  };

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\?|$|\.)/.test(action) && !action.endsWith('/cart/add')) return;
    if (event.submitter && event.submitter.name === 'checkout') return;
    event.preventDefault();
    const buttons = [...form.querySelectorAll('[type="submit"]'), ...document.querySelectorAll('[data-sticky-add]')];
    buttons.forEach(b => b.setAttribute('aria-busy', 'true'));
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) { showError(data.description || data.message); open(); return; }
      const item = Array.isArray(data.items) ? data.items[0] : data;
      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      fill(item, cart);
      open();
    } catch (e) {
      form.submit(); // fall back to the normal cart page
    } finally {
      buttons.forEach(b => b.removeAttribute('aria-busy'));
    }
  });
})();
